import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { ConnectAccountStatus, Vendor, VendorStats } from './marketplace.models';
import { unwrapPage, Paginated } from './pagination.util';

@Injectable({ providedIn: 'root' })
export class VendorService {
  private apiUrl = serviceurl + 'api/v1';

  constructor(private http: HttpClient) {}

  /** Public "All Shops" directory — visible storefronts only. */
  list(): Observable<Vendor[]> {
    return this.http.get<Paginated<Vendor> | Vendor[]>(`${this.apiUrl}/vendors/`).pipe(unwrapPage<Vendor>());
  }

  get(id: number | string): Observable<Vendor> {
    return this.http.get<Vendor>(`${this.apiUrl}/vendors/${id}/`);
  }

  me(): Observable<Vendor> {
    return this.http.get<Vendor>(`${this.apiUrl}/vendors/me/`);
  }

  /** Edit your shop. Send FormData to upload a logo / banner; clear_logo / clear_banner remove them. */
  updateMe(payload: Partial<Vendor> | FormData): Observable<Vendor> {
    return this.http.patch<Vendor>(`${this.apiUrl}/vendors/me/`, payload);
  }

  /** Sales, earnings, reserve and per-item numbers for the seller dashboard. */
  myStats(): Observable<VendorStats> {
    return this.http.get<VendorStats>(`${this.apiUrl}/vendors/me/stats/`);
  }

  acceptTerms(version = '1.0'): Observable<Vendor> {
    return this.http.post<Vendor>(`${this.apiUrl}/vendors/me/accept-terms/`, { version });
  }

  connectOnboardingLink(refreshUrl: string, returnUrl: string): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.apiUrl}/stripe/connect/onboarding-link/`, {
      refresh_url: refreshUrl,
      return_url: returnUrl,
    });
  }

  connectAccountStatus(): Observable<ConnectAccountStatus> {
    return this.http.get<ConnectAccountStatus>(`${this.apiUrl}/stripe/connect/account-status/`);
  }
}
